import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import Box from 'components/Box';
import Button from 'components/Button';
import Card from 'components/Card';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import SortableStack from 'components/SortableStack';
import { DraggableHorizontalCard, TypeIcon } from 'components/ContentCards';
import ConfirmationModal from '../PlaylistEditorModal/ConfirmationModal';
import { useUpdatePlaylistContentDeprecated } from 'actions/playlists';

// On the hub's playlist page, only regular assets and playlist links are numbered,
// while sections don't have a number.
// This function extends asset objects with an `assetNumber` property
// to make it easy to match this numbering.

function getNumberedContentItems(contentItems) {
  var contentItemNumber = 0;
  return contentItems.map(function (item) {
    var hasIndex = item.type !== 'section';
    if (hasIndex) {
      contentItemNumber++;
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      contentItemNumber: hasIndex ? contentItemNumber : undefined
    });
  });
}
function getWasOrderChanged(originalItems, newItems) {
  return !originalItems.every(function (item, index) {
    return item.id === newItems[index].id;
  });
}
function Subtitle(_ref) {
  var icon = _ref.icon,
    type = _ref.type;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var translatedType = t(getContentItemTypeTranslationKey(type));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TypeIcon, {
    name: icon
  }), translatedType);
}
function draggableItemRenderer(_ref2) {
  var item = _ref2.item,
    dragHandleProps = _ref2.dragHandleProps,
    isDragging = _ref2.isDragging;
  var type = getContentItemType(item);
  var icon = getContentItemIconFromType(type);
  var isSection = type === 'section';
  var hasPicture = !isSection && 'pictureUrl' in item && item.pictureUrl;
  return /*#__PURE__*/React.createElement(DraggableHorizontalCard, {
    title: item.name,
    subtitle: /*#__PURE__*/React.createElement(Subtitle, {
      icon: icon,
      type: type
    }),
    index: item.contentItemNumber,
    imageSource: hasPicture ? "".concat(item.pictureUrl, "/w_82,h_55") : undefined,
    icon: !isSection ? icon : undefined,
    isDragging: isDragging,
    dragHandleProps: dragHandleProps
  });
}
function ReorderPlaylistModal(_ref3) {
  var playlistId = _ref3.playlistId,
    _ref3$contentItems = _ref3.contentItems,
    contentItems = _ref3$contentItems === void 0 ? [] : _ref3$contentItems,
    onClose = _ref3.onClose;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var titleId = 'reorder-playlist-title';
  var _useState = useState(contentItems),
    _useState2 = _slicedToArray(_useState, 2),
    sortedContentItems = _useState2[0],
    setSortedContentItems = _useState2[1];
  var wasOrderChanged = getWasOrderChanged(contentItems, sortedContentItems);
  var _useUpdatePlaylistCon = useUpdatePlaylistContentDeprecated(playlistId),
    updatePlaylistContent = _useUpdatePlaylistCon.updatePlaylistContent,
    isLoading = _useUpdatePlaylistCon.isLoading;
  function submit(e) {
    e.preventDefault();
    var newOrder = sortedContentItems.map(function (contentItem, index) {
      return {
        contentId: contentItem.id,
        rank: index + 1
      };
    });
    updatePlaylistContent(newOrder, {
      onSuccess: onClose
    });
  }
  function handleDrop(_ref4) {
    var source = _ref4.source,
      destination = _ref4.destination;
    var startIndex = source === null || source === void 0 ? void 0 : source.index;
    var endIndex = destination === null || destination === void 0 ? void 0 : destination.index;
    if (!destination || startIndex === endIndex) {
      return;
    }
    if (typeof startIndex === 'number' && typeof endIndex === 'number') {
      setSortedContentItems(function (prevContentItems) {
        var newContentItems = _toConsumableArray(prevContentItems);
        var _newContentItems$spli = newContentItems.splice(startIndex, 1),
          _newContentItems$spli2 = _slicedToArray(_newContentItems$spli, 1),
          removedContentItem = _newContentItems$spli2[0];
        newContentItems.splice(endIndex, 0, removedContentItem);
        return newContentItems;
      });
    }
  }
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasConfirmationModal = _useState4[0],
    setHasConfirmationModal = _useState4[1];
  function requestClose() {
    if (wasOrderChanged) {
      setHasConfirmationModal(true);
    } else {
      onClose();
    }
  }
  return /*#__PURE__*/React.createElement(Modal, {
    id: "reorder-playlist",
    width: "wide",
    "aria-labelledby": titleId,
    onRequestClose: requestClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    as: "form",
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('reorder_playlist_title'),
    titleId: titleId,
    subtitle: t('reorder_playlist_description'),
    onClose: requestClose
  }), /*#__PURE__*/React.createElement(Box, {
    borderTop: "thin",
    borderBottom: "thin",
    background: "shaded",
    style: {
      overflowY: 'scroll'
    },
    maxHeight: 400
  }, /*#__PURE__*/React.createElement(SortableStack, {
    p: "xs",
    spacing: "xs",
    onDragEnd: handleDrop,
    items: getNumberedContentItems(sortedContentItems),
    getItemId: function getItemId(item) {
      return String(item.id);
    },
    itemRenderer: draggableItemRenderer
  })), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    isDisabled: !wasOrderChanged || isLoading
  }, t('actions_save_and_close')))), hasConfirmationModal && /*#__PURE__*/React.createElement(ConfirmationModal, {
    editMode: true,
    onConfirm: onClose,
    onCancel: function onCancel() {
      return setHasConfirmationModal(false);
    }
  }));
}
export default ReorderPlaylistModal;